import React from 'react'

const Header = () => {
    return (
        <header>
            <h1 className='header-title'>New albums and singles</h1>
        </header>
    )
}

export default Header;

